import { mapGetters, mapMutations } from 'vuex';
import mvtShifter from '@/common/components/mvtshifter/mvt-shifter.vue';

var time;
export default {
    name: 'dppPhotoNav',
    inject: ['$eventBus'],
    components: {
        mvtShifter,
    },
    data() {
        return {
            imageIndex: null,
            currentCateIndex: 0,
            photoIndex: 0,
        };
    },
    computed: {
        ...mapGetters('glb', ['glb', 'viewport', 'getSplit']),
        ...mapGetters('dpp', ['dpp', 'getCategories', 'getCateIndex', 'getPhotos']),
    },
    mounted() {
        this.updateActiveCate(this.getCateIndex);
    },
    watch: {
        getCateIndex(val) {
            if (time) {
                clearTimeout(time);
            }
            time = setTimeout(() => {
                this.updateActiveCate(val);
            }, 100);
        },
    },
    methods: {
        ...mapMutations('dpp', ['updateCateIndex', 'updateImageIndex']),
        updateActiveCate(val) {
            var $scroller = $('.dpp-photo-nav').find('[data-role="scroller"]');
            var $catImage = $scroller.find(`[data-cateIndex="${val}"]`);
            $scroller.find('.active').removeClass('active');
            $catImage.addClass('active');
            var pLeft = $catImage.offsetParent().offset().left;
            var left = $scroller.scrollLeft() + $catImage.offset().left - pLeft;
            $scroller.scrollLeft(left);
        },
        pop3d(url) {
            this.$eventBus.$emit('property-pop-3d', url);
        },
        changePhotoCate(cateIndex, photoIndex) {
            if (this.dpp.hidePhotosByCompliance) {
                this.$eventBus.$emit('dialog-center', { name: 'mvtAuthenticate', opt: { type: 'mvtLogin' }, trigger: this.$options.name });
                return;
            }
            let item = this.getPhotos.find((e) => {
                return e.cateIndex === cateIndex && e.index === 0;
            });
            if (item) {
                this.updateImageIndex(item.i);
            }
        },
    },
};
